import { apiGet } from './index'

export interface InboxCountersResponse {
  unread_total: number
}

export async function getInboxCounters(stationId: number): Promise<InboxCountersResponse> {
  const params = new URLSearchParams({ station_id: String(stationId) })
  return apiGet<InboxCountersResponse>(`inbox/counters?${params.toString()}`)
}
